(function () {
  const observed = new WeakSet()
  const reported = new WeakSet()

  function productIds(block) {
    return [...block.querySelectorAll('.svc-card[data-product-id]')]
      .map((card) => String(card.dataset.productId || ''))
      .filter(Boolean)
      .filter((id, index, ids) => ids.indexOf(id) === index)
  }

  function emit(action, block, card, interaction) {
    const detail = {
      action,
      block: block?.dataset.recommendationBlock || '',
      source: block?.dataset.recommendationSource || '',
      productId: card?.dataset.productId || '',
      position: Number(card?.dataset.position || 0) || null,
      interaction: interaction || '',
      productIds: action === 'impression' ? productIds(block) : undefined,
      pageType: window.ShopifyAnalytics?.meta?.page?.pageType || document.body.dataset.template || '',
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: `recommendation_${action}`,
      recommendation: detail,
    })

    if (typeof window.psGtag === 'function') {
      window.psGtag('event', `recommendation_${action}`, {
        block: detail.block,
        source: detail.source,
        product_id: detail.productId,
        position: detail.position,
        interaction: detail.interaction,
        page_type: detail.pageType,
      })
    }

    document.dispatchEvent(new CustomEvent('promosound:recommendation', { detail }))

    if (typeof window.clarity === 'function') {
      window.clarity('event', `recommendation_${action}`)
    }
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.25 || reported.has(entry.target)) return
        reported.add(entry.target)
        emit('impression', entry.target)
        observer.unobserve(entry.target)
      })
    }, { threshold: [0.25] })
    : null

  function observeBlocks(scope = document) {
    scope.querySelectorAll('[data-recommendation-block]').forEach((block) => {
      if (observed.has(block) || block.hidden) return
      observed.add(block)
      if (observer) observer.observe(block)
      else if (!reported.has(block)) {
        reported.add(block)
        emit('impression', block)
      }
    })
  }

  function observeNode(node) {
    if (!(node instanceof Element)) return
    if (node.matches('[data-recommendation-block]')) observeBlocks(node.parentElement || document)
    else observeBlocks(node)
  }

  document.addEventListener('click', (event) => {
    const interaction = event.target.closest('[data-recommendation-action], a, button')
    const card = interaction?.closest('.svc-card[data-product-id]')
    const block = card?.closest('[data-recommendation-block]')
    if (!block || !card) return

    const action = interaction.dataset.recommendationAction
      || (interaction.classList.contains('add_to_cart_button') ? 'add-to-cart' : '')
      || (interaction.matches('a') ? 'product-click' : 'button-click')
    emit(action === 'add-to-cart' ? 'add_to_cart' : 'click', block, card, action)
  })

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') observeNode(mutation.target)
      mutation.addedNodes.forEach(observeNode)
    })
  })

  document.addEventListener('DOMContentLoaded', () => {
    observeBlocks()
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden'],
    })
  })
})()
